import { getSubStepValues } from '#models/general/steps';
import Input from '#components/general/Input';
import { FROM_0_TO_99_REGEX } from '#utils/string/regex';
import { getCheckboxesPercentagesRows } from '#models/general/fields/checkboxPercentage';

import { FERMENTATION_FIELDS, NEW_PRODUCT_SUBSTEPS_IDS } from './constants';
import { getOperatorsForStep } from './utils';

const OPERATORS = {
  MARK_GIESLER: 'markGiesler',
  GORDON_MACKENZIE: 'gordonMackenzie',
  ROSS_HUGHES: 'rossHughes',
  NICKY_DOCHERTY: 'nickyDocherty',
  CHRIS_ANDERSON: 'chrisAnderson',
  SCOTT_STEWART: 'scottStewart',
  STEWART_CONNOR: 'stewartConnor',
  ALASTAIR_MACKAY: 'alastairMackay',
  DJ_CAMERON: 'djCameron',
  ALLY_FISHER: 'allyFisher',
  LOUIS_MACKENZIE: 'louisMackenzie'
};

export const FERMENTED_BY_OPTIONS = getOperatorsForStep(OPERATORS, 'Fermented');

export const getFermentationFields = ({ values, errors }) => {
  const getFermentationValues = getSubStepValues(NEW_PRODUCT_SUBSTEPS_IDS.FERMENTATION, values, errors);
  return [
    ...getCheckboxesPercentagesRows(
      Object.values(FERMENTED_BY_OPTIONS),
      getFermentationValues,
      values,
      'Fermented'
    ),
    {
      ...getFermentationValues(FERMENTATION_FIELDS.AVERAGE_HOURS),
      Component: Input,
      needsRegex: true,
      customRegex: FROM_0_TO_99_REGEX,
      noMargin: true
    },
    {
      ...getFermentationValues(FERMENTATION_FIELDS.TYPE_OF_YEAST),
      Component: Input,
      noMargin: true
    }
  ];
};
